import { getKeysAsDictionary } from '@core/util';
import {
  AboutYouModel,
  AboutYourBusinessFinancialRequired,
  AuthorizedPersonnelModel,
  BeneficialOwnerModel,
  BoardResolutionApprovingPersonsModel,
  BoardResolutionModel,
  BusinessAccountModel,
  BusinessDeclarationUsPerson,
  BusinessEntityModel,
  CollateralPropertyModel,
  CommonReportingForEntityModel,
  CommonReportingStandardModel,
  CreditReportRequestModel,
  ESignatureModel,
  FatcaModel,
  HdbOwnershipPropertyModel,
  MarketingConsentModel,
  MyInfoBusinessModel,
  PersonnelAddressModel,
  UsPersonModel,
} from '../model';
import { AddressModel } from '@core/address';
import { CrsTaxResidenceModel } from '@core/data-access';

export const AddressModelKeys = getKeysAsDictionary(AddressModel);
export const PersonnelAddressModelKeys = getKeysAsDictionary(PersonnelAddressModel);
export const AuthorizedPersonnelModelKeys = getKeysAsDictionary(AuthorizedPersonnelModel);
export const FinancialRequiredModelKeys = getKeysAsDictionary(AboutYourBusinessFinancialRequired);
export const CollateralPropertyModelKeys = getKeysAsDictionary(CollateralPropertyModel);
export const BusinessEntityModelKeys = getKeysAsDictionary(BusinessEntityModel);
export const CommonReportingForEntityModelKeys = getKeysAsDictionary(CommonReportingForEntityModel);
export const CrsTaxResidenceKeys = getKeysAsDictionary(CrsTaxResidenceModel);
export const MyInfoBusinessModelKeys = getKeysAsDictionary(MyInfoBusinessModel);
export const BusinessAccountModelKeys = getKeysAsDictionary(BusinessAccountModel);
export const BeneficialOwnerModelKeys = getKeysAsDictionary(BeneficialOwnerModel);
export const BoardResolutionModelKeys = getKeysAsDictionary(BoardResolutionModel);
export const BoardResolutionApprovingPersonsModelKeys = getKeysAsDictionary(BoardResolutionApprovingPersonsModel);
export const BusinessDeclarationUsPersonKeys = getKeysAsDictionary(BusinessDeclarationUsPerson);
export const UsPersonModelKeys = getKeysAsDictionary(UsPersonModel);
export const CreditReportRequestModelKeys = getKeysAsDictionary(CreditReportRequestModel);
export const CommonReportingStandardModelKeys = getKeysAsDictionary(CommonReportingStandardModel);
export const FatcaModelKeys = getKeysAsDictionary(FatcaModel);
export const ESignatureModelKeys = getKeysAsDictionary(ESignatureModel);
export const AboutYouModelKeys = getKeysAsDictionary(AboutYouModel);
export const MarketingConsentModelKeys = getKeysAsDictionary(MarketingConsentModel);
export const HdbOwnershipPropertyModelKey = getKeysAsDictionary(HdbOwnershipPropertyModel);
